;(function () {
  'use strict'

  angular.module('contrast.licenses-activity-series').constant('CHART_EVENTS', {
    DRILLDOWN_LICENSE_ACTIVITY_TO_AGENT_USAGE:
      'chart.drilldown.licensesActivity.agentUsage',
    DRILLDOWN_AGENT_USAGE_TO_USAGE_HOURS:
      'chart.drilldown.agentUsage.usageHours',
    DRILLDOWN_USAGE_HOURS_TO_AGENT_USAGE:
      'chart.drilldown.usageHours.agentUsage',
    LOAD_PROTECT_USAGE: 'chart.load.protectUsage',
    RENDER_LICENSES_ACTIVITY: 'chart.render.licensesActivity'
  })
})()
